import { TaxFormType } from "../../../../../../Wrap/Constants/Enums/Customer/TaxFormType";
import { TaxExemptionReason } from "../../../../../../Wrap/Constants/Enums/Customer/TaxExemptionReason";
import { TaxResidencyForPensionRelief } from "../../../../../../Wrap/Constants/Enums/Customer/TaxResidencyForPensionRelief";

export enum RegulatoryTabs {
    CustomerTaxResidency = "Customer tax residency and nationality details",
    CustomerCitizenship = "Customer citizenship",
    TaxForm = "Tax form information",
    ReportingTaxYearSetting = "Reporting tax year setting",
    TaxExemption = "Tax exemption",
    HighValue = "High value",
    ControllingPersonDetails = "Controlling Person Details",
}

export const TaxResidencyForPensionReliefTypes = [
    TaxResidencyForPensionRelief.Unknown,
    TaxResidencyForPensionRelief.Scottish,
    TaxResidencyForPensionRelief.RestOfUK,
    TaxResidencyForPensionRelief.Welsh,
];
export const TaxResidencyForPensionReliefMap = {
    [TaxResidencyForPensionRelief.Unknown]: "Unknown",
    [TaxResidencyForPensionRelief.Scottish]: "Scottish",
    [TaxResidencyForPensionRelief.RestOfUK]: "Rest of UK",
    [TaxResidencyForPensionRelief.Welsh]: "Welsh",
};

export const TaxFormTypes = [TaxFormType.W8BEN, TaxFormType.W9];
export const TaxFormTypeMap = {
    [TaxFormType.W8BEN]: "W-8BEN",
    [TaxFormType.W9]: "W-9",
};

export const TaxExemptionReasons = [TaxExemptionReason.NonTaxResident];
export const TaxExemptionReasonMap = {
    [TaxExemptionReason.NonTaxResident]: "Non tax resident",
};

export const RegulatoryContents = {
    CkbNotOwnIdentifier: "I don't own this identifier",
    LblNationalIdentifier: "National identifier",
    LblPassport: "Passport number",
    TaxReferenceType: "Tax reference type*",
    TaxReference: "Tax reference*",
};
